import React from "react";
import { searchSkills } from "../../../graphql/queries";
import * as ModelTypes from "../../../graphql/Constants/ModelTypes";
import DataGrid from "../../Common/DataGrid";
import * as DataTypes from "../../../constants/Data/DataTypes";
import * as QueryTypes from "../../../graphql/Constants/QueryTypes";

const Skills = (props) => {
    return (
        <DataGrid
          {...props}
          header="Skills"
          gridObjectDataModel={[
            { name: "name", headerText: "Name", type: DataTypes.String },
            { name: "order", headerText: "Order", type: DataTypes.Number },
            {
              name: "createdAt",
              headerText: "Created At",
              type: DataTypes.DateTime,
            },
          ]}
          modelType={ModelTypes.Skill}
          queryFunction={searchSkills}
          queryFunctionType={QueryTypes.Search}
          queryName={"searchSkills"}
          hasCreate={true}
          hasDetails={true}
          hasEdit={true}
          hasDelete={true}
          baseRoute={"skills"}
        />
      );
};

export default Skills;
